import React, { useState } from 'react';
import styles from './PopupEditClient.module.css';
import { editsCustomerDataBd } from '../../firebase';
import { useDispatch } from 'react-redux';
import LoaderPage from '../LoaderPage/LoaderPage';
import { editsCustomerDataRedux } from '../../store/slices/clientsSlice';

export default function PopupEditClient({ client, handleClick }) {
  const dispatch = useDispatch();
  const [name, setName] = useState(client.name);
  const [surname, setSurname] = useState(client.surname);
  const [tel, setTel] = useState(client.tel);
  const [fromAdvertising, setFromAdvertising] = useState(client?.fromAdvertising || false);
  const [potentialClient, setPotentialClient] = useState(client?.potentialClient || false);
  const [ownСlient, setOwnСlient] = useState(client?.ownСlient || false);

  const [loader, setLoader] = useState(false);

  //Редагує дані клієнта
  const editsCustomerData = async (
    client,
    nameProps,
    surnameProps,
    telProps,
    fromAdvertisingProps,
  ) => {
    setLoader(true);
    const name = nameProps.trim();
    const surname = surnameProps.trim();
    const tel = telProps.trim();

    const newClientData = {
      ...client,
      newClient: false,
      name: name,
      surname: surname,
      tel: tel,
      fromAdvertising: fromAdvertisingProps, // Чи цей клієнт прийшов з реклами
      ownСlient: ownСlient, // Клієнт був на супроводі
      potentialClient: potentialClient, // Потенційний клієнт
      fullName: name + ' ' + surname,
    };

    const isEditsCustomerDataBd = await editsCustomerDataBd(newClientData);

    handleClick(false);
    if (isEditsCustomerDataBd) {
      dispatch(editsCustomerDataRedux(newClientData));
    }
    setLoader(false);
  };

  return (
    <>
      <div className={styles.popup_wrapper}>
        <div className={styles.popup_contnent_wrapper}>
          <button className={styles.popup_close_btn} onClick={() => handleClick(false)}>
            Закрити
          </button>
          Ім’я
          <input
            value={name}
            className={styles.popup_input}
            type="text"
            onChange={(e) => setName(e.target.value)}
          />
          Прізвище
          <input
            value={surname}
            className={styles.popup_input}
            type="text"
            onChange={(e) => setSurname(e.target.value)}
          />
          Телефон
          <input
            value={tel}
            className={styles.popup_input}
            type="tel"
            onChange={(e) => setTel(e.target.value)}
          />
          <div className={styles.fromAdvertising_wrapper + ' mb_15'}>
            Клієнт з реклами
            <div
              className={
                fromAdvertising
                  ? styles.fromAdvertising_btn_active + ' ' + styles.fromAdvertising_btn
                  : styles.fromAdvertising_btn
              }
              onClick={() => (
                setFromAdvertising(!fromAdvertising), setOwnСlient(false), setPotentialClient(false)
              )}></div>
          </div>
          <div className={styles.fromAdvertising_wrapper + ' mb_15'}>
            Клієнт був на супроводі
            <div
              className={
                ownСlient
                  ? styles.ownСlient_btn_active + ' ' + styles.fromAdvertising_btn
                  : styles.fromAdvertising_btn
              }
              onClick={() => (
                setOwnСlient(!ownСlient), setFromAdvertising(false), setPotentialClient(false)
              )}></div>
          </div>
          <div className={styles.fromAdvertising_wrapper}>
            Потенційний клієнт
            <div
              className={
                potentialClient
                  ? styles.potentialClient_btn_active + ' ' + styles.fromAdvertising_btn
                  : styles.fromAdvertising_btn
              }
              onClick={() => (
                setPotentialClient(!potentialClient), setOwnСlient(false), setFromAdvertising(false)
              )}></div>
          </div>
          <div className={styles.popup_add_btn_wrapper}>
            <button
              className={styles.popup_add_btn}
              onClick={() => editsCustomerData(client, name, surname, tel, fromAdvertising)}>
              Змінити
            </button>
          </div>
        </div>
      </div>
      {loader && <LoaderPage />}
    </>
  );
}
